import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import "../css/standings.css";
import { statSeason } from "./vars";
import { TeamRankCard } from "../modules/leagueStandings";

const rapidApiHost = process.env.REACT_APP_RAPID_API_HOST;
const rapidApiKey = process.env.REACT_APP_RAPID_API_KEY;

export function UseStandingsConf() {
  return useQuery({
    queryKey: ["teamStandingsConf"],
    queryFn: async () => {
      try {
        // Try backend cache first
        const backendUrl = `/api/nfl-standings/${statSeason}`;
        const response = await fetch(backendUrl);
        
        if (response.ok) {
          const data = await response.json();
          return {
            ...data,
            fetchedAt: new Date().toLocaleTimeString(),
          };
        }
        
        // Fallback to direct RapidAPI if backend fails
        console.warn('Backend unavailable, falling back to RapidAPI');
        throw new Error('Backend unavailable');
      } catch (backendError) {
        // Direct RapidAPI fallback
        const response = await fetch(
          "https://tank01-nfl-live-in-game-real-time-statistics-nfl.p.rapidapi.com/getNFLTeams?sortBy=conference&rosters=false&schedules=false&topPerformers=false&teamStats=false&standingsSeason=" +
            statSeason,
          {
            method: "GET",
            headers: {
              "x-rapidapi-host": rapidApiHost,
              "x-rapidapi-key": rapidApiKey,
            },
          }
        );
        const data = await response.json();
        return {
          ...data,
          fetchedAt: new Date().toLocaleTimeString(),
        };
      }
    },
    staleTime: 48 * 60 * 60 * 1000, // 48 hours
    cacheTime: 168 * 60 * 60 * 1000, // 7 days
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
}

export function GetTeamStandingsConf(props) {
  // props.c = conference

  const { data, isLoading, error } = UseStandingsConf();

  // local state to hold standings array (or null until loaded)
  const [standings, setStandings] = useState(null);

  // Sync query data into local state when it becomes available
  useEffect(() => {
    if (!data) return;

    // convert to array and drop the last entry (fetched time)
    let teamStandings = Object.values(data).slice(1, 2);
    teamStandings = teamStandings[0];

    setStandings(teamStandings);
  }, [data]);

  if (isLoading) return <div>Loading team data...</div>;
  if (error) return <div>Error loading team data: {error.message}</div>;

  if (!standings) return <div>No standings available</div>;

  const output = standings
    .filter((d) => d.conferenceAbv === props.c)
    .map((data, i) => {
      let theTeam = data.teamAbv;
      if (theTeam === "WAS") {
        theTeam = "WSH";
      }
      const theRecord =
        data.wins + "-" + data.loss + (data.tie !== "0" ? "-" + data.tie : "");
      return (
        <TeamRankCard
          key={theTeam}
          k={i}
          rank={i + 1}
          t={theTeam}
          record={theRecord}
        />
      );
    });

  return <>{output}</>;
}
